export function getEnv() {
    let envLocation = window.location.origin;

    switch (envLocation) {
        //local development
        case "http://localhost:3000":
            // return {
            //     ENDPOINT: 'http://localhost:2005',
            //     KEYCLOAK_URL: 'http://18.224.32.110',
            //     REALM: 'TFGBVRealm',
            //     CLIENT_ID: 'TFGBVClient',
            //     ENVIRONMENT: 'development',
            //     DEBUG_MODE: true,
            //     LOG_LEVEL: 'debug',
            //     AUTH_METHOD: 'keycloak',
            //     CLIENT_SECRET: 'T7O1MpelOdjyj337ynq9bqgUtDi2BcBD' // jwt or 'keycloak'
            // }
           
            // return {
            //     ENDPOINT: 'http://20.57.142.39',
            //     ENVIRONMENT: 'development',
            //     DEBUG_MODE: true,
            //     LOG_LEVEL: 'debug',
            //     AUTH_METHOD: 'jwt'
            // }
            //     return {
            //     ENDPOINT: 'http://20.114.21.212',
            //     ENVIRONMENT: 'development',
            //     DEBUG_MODE: true,
            //     LOG_LEVEL: 'debug',
            //     AUTH_METHOD: 'jwt'
            // }
            return {
                ENDPOINT: 'https://bringmyfood.online',
                VAPID_PUBLIC_KEY: 'BA-j25tO6EgXbAO1sln0uh5F9ldFAOg7h8mUkbnDDX7QsnMo5j4RBhVpanMcdn-HvpDKmcJW-gr4JZR3P96ZLM0',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'jwt'
            }

        //testing server
        case "http://20.57.142.39":
            return {
                ENDPOINT: 'http://20.57.142.39',
                VAPID_PUBLIC_KEY: 'BA-j25tO6EgXbAO1sln0uh5F9ldFAOg7h8mUkbnDDX7QsnMo5j4RBhVpanMcdn-HvpDKmcJW-gr4JZR3P96ZLM0',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'jwt'
            }
        //Live server
        case "https://bringmyfood.online":
            return {
                ENDPOINT: 'https://bringmyfood.online',
                VAPID_PUBLIC_KEY: 'BA-j25tO6EgXbAO1sln0uh5F9ldFAOg7h8mUkbnDDX7QsnMo5j4RBhVpanMcdn-HvpDKmcJW-gr4JZR3P96ZLM0',
                ENVIRONMENT: 'production',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'jwt'
            }

        default:
            return {
                ENDPOINT: 'http://20.57.142.39',
                VAPID_PUBLIC_KEY: 'BA-j25tO6EgXbAO1sln0uh5F9ldFAOg7h8mUkbnDDX7QsnMo5j4RBhVpanMcdn-HvpDKmcJW-gr4JZR3P96ZLM0',
                ENVIRONMENT: 'production',
                DEBUG_MODE: false,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'jwt'
            }
    }
}

// Helper function to get environment variable with fallback
export function getEnvVar(key, defaultValue = '') {
    const env = getEnv();
    return env[key] || defaultValue;
}

// Helper function to check if we're in development mode
export function isDevelopment() {
    return getEnv().ENVIRONMENT === 'development';
}

// Helper function to check if debug mode is enabled
export function isDebugMode() {
    return getEnv().DEBUG_MODE === true;
}